import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateFeeResponse from "./customerRefundCandidateFeeResponse";
import CustomerRefundPaymentType from "./customerRefundPaymentType";
import FailedRefundReason from "./failedRefundReason";
import RefundDisplayStatus from "./refundDisplayStatus";
import RefundDisplayType from "./refundDisplayType";
import RefundPayGatePaymentResponse from "./refundPayGatePaymentResponse";
import RefundTransferPaymentResponse from "./refundTransferPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeRefundResponse {
  @observable
  refundDisplayStatus!: RefundDisplayStatus;

  @observable
  failReason?: FailedRefundReason;

  @observable
  refundDisplayType!: RefundDisplayType;

  @observable
  originalChargePrice!: number;

  @observable
  amount!: number;

  @observable
  @Type(() => CustomerRefundCandidateFeeResponse)
  fees!: CustomerRefundCandidateFeeResponse[];

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  createdBy!: string;

  @observable
  @Type(() => Date)
  approvedAt?: Date;

  @observable
  approvedBy?: string;

  @observable
  @Type(() => Date)
  rejectedAt?: Date;

  @observable
  rejectedBy?: string;

  @observable
  customerRefundPaymentType?: CustomerRefundPaymentType;

  @observable
  @Type(() => Date)
  exportedAt?: Date;

  @observable
  variableSymbol?: number;

  @observable
  @Type(() => RefundTransferPaymentResponse)
  refundTransferPayment?: RefundTransferPaymentResponse;

  @observable
  @Type(() => RefundPayGatePaymentResponse)
  refundPayGatePayment?: RefundPayGatePaymentResponse;

  @observable
  officialRecordId?: string;
}
